export type AgreementResponse = {
  content: string;
}

export enum AgreementTypes {
  userAgreement = 'UserAgreement',
  gdprAgreement = 'gdprAgreement',
}